<template>
  <el-card shadow="never">
    <el-form label-position="top" :inline="true">
      <el-form-item label="Дата">
        <el-date-picker v-model="date" type="date" />
      </el-form-item>
      <el-form-item label="Время">
        <el-select v-model="time" filterable>
          <el-option v-for="time in availableShifts" :key="time" :label="time" :value="time" />
        </el-select>
      </el-form-item>
      <el-form-item label="Стажер">
        <el-switch v-model="isIntern" size="small" />
      </el-form-item>
      <AddIncome v-model="income" v-model:screenshots="screenshots" />
      <el-form-item>
        <el-button type="primary" @click="assignShift">Отправить отчет</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script setup lang="ts">
import { api } from '@/api'
import { ElMessage, type UploadFile } from 'element-plus'
import { ref } from 'vue'
import type Chatter from '@/api/resources/chatters/model'
import { ChatterStatus } from '@/api/resources/chatters/model'
import type { IncomeToCreate } from '@/api/resources/incomes.ts/model'
import { availableShifts } from '@/data/shifts'
import AddIncome from './AddIncome.vue'
import { convertToUTC } from '@/utils/date'

const props = defineProps<{
  chatter: Chatter
}>()

const income = ref<Partial<IncomeToCreate>>({
  in_progress: undefined,
  unread: undefined,
  comment: '',
  model: '',
  amount: undefined,
  is_delayed: false,
  success_poor_detects: undefined,
  failed_poor_detects: undefined,
})

const screenshots = ref<UploadFile[]>([])

const emit = defineEmits<{
  (e: 'change', shiftId: number, income: IncomeToCreate, screenshots: UploadFile[]): void
}>()

const date = ref(new Date())
const isIntern = ref(
  [ChatterStatus.ZERO_SHIFT, ChatterStatus.FIFTH_SHIFT].includes(props.chatter.status),
)
const time = ref()

const assignShift = async () => {
  const shiftId = await api.assignShift({
    payload: {
      chatterId: Number(props.chatter.id),
      date: convertToUTC(date.value),
      isIntern: isIntern.value,
      time: time.value,
    },
  })

  ElMessage.success('Смена сохранена')
  emit('change', shiftId, income.value as IncomeToCreate, screenshots.value)
}
</script>

<style langs="scss" scoped>
.el-form-item:last-child {
  margin-top: 20px;
  :deep(.el-form-item__content) {
    justify-content: flex-end;
  }
}
</style>
